<template>
    <menu-float>
        <h2>
            <i v-if="active_icon_categories" class="fas fa-bars"></i>
            <span>Busque por categoria</span>
        </h2>
        <template v-if="categories && categories.length">
            <ul>
                <li v-for="(cat, i) in categories" :key="'menu-'+i" :id="'menu-'+i">
                    <a :href="!cat.link ? `${route}/${cat.id}/${cat.cat_slug}` : cat.link">
                        {{ cat.cat_name }}
                        <span v-if="cat.subs && cat.subs.length" @click.stop.prevent="toggleActive('menu-'+i)"></span>
                    </a>
                    <template v-if="cat.subs && cat.subs.length">
                        <ul>
                            <li v-for="(sub, index) in cat.subs" :key="'sub-'+index" :id="'menu-'+i+'-'+index">
                                <a :href="!sub.link ? `${route}/${sub.id}/${sub.cat_slug}` : sub.link" :title="sub.cat_name">
                                    {{ sub.cat_name }}
                                    <span v-if="sub.subs && sub.subs.length" @click.stop.prevent="toggleActive('menu-'+i+'-'+index)"></span>
                                </a>
                                <template v-if="sub.subs && sub.subs.length">
                                    <ul>
                                        <li v-for="(subsub, inx) in sub.subs" :key="'subsub-'+inx" :id="'menu-'+i+'-'+index+'-'+inx">
                                            <a :href="!subsub.link ? `${route}/${subsub.id}/${subsub.cat_slug}` : subsub.link" :title="subsub.cat_name">
                                                {{ subsub.cat_name }}
                                                <span v-if="subsub.subs && subsub.subs.length" @click.stop.prevent="toggleActive('menu-'+i+'-'+index+'-'+inx)"></span>
                                            </a>
                                            <template v-if="subsub.subs && subsub.subs.length">
                                                <ul>
                                                    <li v-for="(subsubsub, indx) in subsub.subs" :key="'subsubsub'+indx">
                                                        <a :href="!subsubsub.link ? `${route}/${subsubsub.id}/${subsubsub.cat_slug}` : subsubsub.link" :title="subsubsub.cat_name">
                                                            {{ subsubsub.cat_name }}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </template>
                                        </li>
                                    </ul>
                                </template>
                            </li>
                        </ul>
                    </template>
                </li>
            </ul>
        </template>
    </menu-float>
</template>

<script>
import { CMenuFloat } from '../Styles/Header/styled'
export default {
    name: 'MenuCategoriesHome',
    props: {
        active_icon_categories: Boolean,
        categories: Array, 
        route:String
    },
    components: {
        'menu-float': CMenuFloat
    },
    methods: {
        toggleActive(id) {
            let element = document.getElementById(id)
            element.classList.toggle('active')
        }
    }
}
</script>